import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import WatchCamerasApi from './WatchCamerasApi';

let settings;

export default settings = {
    key: 'watch/cameras',
    zone: 'watch',
    path: '/watch/cameras',
    title: "Watch Cameras",
    endpoint: WatchCamerasApi.endpoint,
    modelName: 'WatchCameras',
    idKey: 'id',
    primaryKey: 'name',
    actions: ['trash', 'clone'],
    indexCaps: ["viewWatchCameras"],
    viewCaps: ["viewWatchCameras"],
    createCaps: ["createWatchCameras"],
    updateCaps: ["updateWatchCameras"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [

        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: WatchCamerasApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: [], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.type) filters.where.type = params.type;

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['name'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Name",
                key: "name",
                type: "text",
            },

        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "Name",
                key: "this",
                format: "ModelLink",
                sort: 'title'
            },
            {
                label: "Online",
                key: "online",
                format: "switch",
            },
            {
                label: "Status",
                key: "status",
                format: "titleCase",
            },
            {
                label: "Updated Date",
                key: "created",
                format: "OnAndBy",
                sort: "updated.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                format: "actions",
                api: WatchCamerasApi,
                settings: settings,
            }
        ];

        return columns;

    },
    singleFetch: WatchCamerasApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: [] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            {
                label: "Edit",
                path: path + "/edit"
            },
        ]

    },
};